module.exports = __webpack_public_path__ + "static/media/ReefCafeLogo-Home.5f8ac6b5.svg";